import { useEffect, useState } from "react";
import Gallery from "../components/Gallery";
import Hero from "../components/Hero";
import Image from "../components/Image";
import Navbar from "../components/Navbar";
import Product from "../components/Product";
import { getFeatured, ProductType } from "../services/api";
import ProductContainer from "../components/ProductContainer";
import Button from "../components/Button";
import "../stylesheets/pages/homepage.scss";
import Footer from "../components/Footer";
import LinkCard from "../components/LinkCard";
import { ReactComponent as LocationIcon } from "../assets/icons/location.svg";
import { ReactComponent as ArrowIcon } from "../assets/icons/right-arrow.svg";
import { ReactComponent as PhoneIcon } from "../assets/icons/phone.svg";
import { ReactComponent as BookingIcon } from "../assets/icons/booking.svg";

// CONST

const maps =
	"https://www.google.com/maps/place/5+Rue+Damiette,+76000+Rouen/@49.43715,1.0947649,15.91z/data=!4m6!3m5!1s0x47e0de7f37ef3101:0x2436d4f931c96654!" +
	"8m2!3d49.4400855!4d1.097986!16s%2Fg%2F11q2vvy6qn?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D";

function Homepage() {
	// STATES
	const [products, setProducts] = useState<ProductType[]>([]);
	// USE EFFECT
	useEffect(() => {
		const fetchProduct = async () => {
			try {
				const response = await getFeatured();
				setProducts(
					response.products.sort(
						(p1: ProductType, p2: ProductType) => {
							if (p1.index && p2.index) {
								return p1.index > p2.index
									? 1
									: p1.index == p2.index
										? 0
										: -1;
							}
							return 0;
						},
					),
				);
			} catch (e) {
				// rien
			}
		};
		fetchProduct();
	}, []);
	return (
		<>
			<Navbar />
			<Hero
				image="/assets/hero/accueil.jpg"
				title="LE PETIT BAR"
				subtitle="COCKTAILS"
				showSchedule={true}
			/>
			<Gallery />
			<section className="menu-section">
				<div className="text-content">
					<h2>Nos Suggestions Du Moment</h2>
					<p className="primary-text">
						Laissez-vous surprendre par les créations de notre
						mixologue. Inspirées par la saison et l'air du temps,
						nos suggestions du moment mêlent audace et raffinement.
						Osez l'inattendu.
					</p>
				</div>

				<div className="menu-display">
					<div>
						<ProductContainer>
							{products.map((product) => (
								<Product
									key={product.name}
									name={product.name}
									ingredients={product.ingredients}
									price={product.price}
									id={product.id}
									isFeatured={true}
								/>
							))}
						</ProductContainer>
						<Button
							variant="filled"
							text="VOIR LA CARTE"
							redirection="/menu"
							icon={<ArrowIcon />}
						/>
					</div>
					<img src="/assets/homepage/menu.png" />
				</div>
			</section>
			<section className="speakeasy">
				<h2>Le Speakeasy De Rouen</h2>
				<p className="primary-text">
					Situé dans le quartier historique médiéval de Rouen, "Le
					Petit Bar" vous invite à savourer un cocktail dans une
					ambiance années 1920 et ce, au pied de l'église saint
					Maclou.
				</p>
				<Button
					text="VOIR SUR MAPS"
					variant="filled"
					redirection={maps}
					icon={<ArrowIcon />}
				/>
				<Button
					text="ÉVÈNEMENTS"
					variant="empty"
					redirection="/events"
					icon={<LocationIcon />}
				/>
			</section>
			<section className="card-section">
				<LinkCard
					title="Réservations"
					img="/assets/homepage/reservations.jpg"
				>
					<p>
						Au Petit Bar, chaque visite est une occasion spéciale.
						Que ce soit pour un verre entre amis ou une soirée plus
						intime, nous serons ravis de vous accueillir dans une
						ambiance chaleureuse et conviviale
					</p>
					<Button
						text="RÉSERVER"
						redirection="/booking"
						variant="filled"
						icon={<BookingIcon />}
					/>
				</LinkCard>
				<LinkCard
					title="Soirées Privatisées"
					img="/assets/homepage/privatisation.jpg"
				>
					<p>
						Pour vos soirées privées ou professionelles, il est
						possible de privatiser "Le Petit Bar". Contactez-nous
						pour formuler vos besoins afin de vous proposer un devis
						sur mesure.
					</p>
					<Button
						text="CONTACTER"
						redirection="/contact"
						variant="filled"
						icon={<PhoneIcon />}
					/>
				</LinkCard>
			</section>
			<Footer />
		</>
	);
}

export default Homepage;
